export default __webpack_public_path__ + "static/media/SENAIT_NL_SEQ08.a8f49e30.mp3";